import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { MEDIA_AGENT_POOL_CONFIG_QUERY_KEY } from '@/state/queries/media-agent-admin/use-media-agent-pool-config';
import type {
  MediaAgentPoolConfigDto,
  MediaAgentPoolConfigPatchDto,
} from '@/types/dtos/media-agent/media-agent-pool.dto';

export function useUpdateMediaAgentPoolConfigMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (patch: MediaAgentPoolConfigPatchDto) => {
      const token = (await getToken()) ?? '';
      const url = `${import.meta.env.VITE_API_URL}/media-agent/pool-config`;
      const result = (await sendJSONRequest({
        url,
        method: METHOD.PATCH,
        body: patch,
        token: token ?? '',
      })) as { config: MediaAgentPoolConfigDto };
      return result.config;
    },
    onSuccess: (config) => {
      queryClient.setQueryData([MEDIA_AGENT_POOL_CONFIG_QUERY_KEY], config);
    },
  });
}
